
/**
 * 时间戳格式化
 * @param date
 * @returns {string}
 */
export function timestamp2std(date) {
	const addZero = num => num > 9 ? num : ('0' + num)
	return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${addZero(date.getHours())}:${addZero(date.getMinutes())}:${addZero(date.getSeconds())}`
}

/**
 * 时间戳格式化
 * @param strtime
 * @returns {number}
 */
export function Time2MSec(strtime) {
	return (new Date(strtime)).getTime();
}

/**
 * 时间戳格式化
 * @param t
 * @returns {number}
 */
export function Time2Sec(t) {
	return Date.parse(new Date(t)) / 1000;
}



export function formatDate(time) {
	var date = new Date(parseInt(time * 1000));
	var year = date.getFullYear();
	var mon = date.getMonth() + 1;
	var day = date.getDate();
	

	mon =  mon <= 9 ? '0'+mon: mon
	day =  day <= 9 ? '0'+day: day

	

	return year + '-' + mon + '-' + day;
}